module.exports = __webpack_public_path__ + "img/mpgovernment.0b487fe3.png";